export default [
    "pppoename",
    "pppoepass",
    "lip",
    "gateway",
    "dns",
    "linterval",
]